export function NotificationItemSkeleton() {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="w-full p-6 rounded flex mb-2 shadow-sm bg-gray-50 dark:bg-gray-700 animate-pulse"
        >
          <div className="focus:outline-none w-10 h-10 border rounded-full border-gray-200 dark:border-gray-600 flex items-center justify-center bg-gray-200 dark:bg-gray-500"></div>
          <div className="pl-3 flex flex-col space-y-1 flex-1">
            <div className="w-40 h-4 bg-gray-200 dark:bg-gray-500 rounded"></div>
            <div className="w-32 h-4 bg-gray-200 dark:bg-gray-500 rounded"></div>
          </div>
        </div>
      ))}
    </>
  );
}
